import { render, staticRenderFns } from "./PaperCom.vue?vue&type=template&id=3f64ee43&scoped=true"
import script from "./PaperCom.vue?vue&type=script&lang=js"
export * from "./PaperCom.vue?vue&type=script&lang=js"
import style0 from "./PaperCom.vue?vue&type=style&index=0&id=3f64ee43&prod&lang=scss"
import style1 from "./PaperCom.vue?vue&type=style&index=1&id=3f64ee43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f64ee43",
  null
  
)

export default component.exports